import { IForm } from "api/rpc/2024-04/guest/form";
import { APIGet, APIUrl, AdminType, StatusCode } from "api/protocols";
import { IOrder } from "redux/reducers/models/order";

export type FormInputTypes = "input" | "select" | "checkbox";

interface IFormResponseRes<T> {
  status: StatusCode;
  data: Array<T>;
  message?: string;
}

export type FormResponseInput = {
  id: number;
  form_response_id: number;
  form_input_id: number;
  label: string;
  type: FormInputTypes;
  value: string;
};

export type FormResponse = {
  id: number;
  form_id: number;
  form: IForm;
  cart_id: number;
  order_id: number;
  customer_id: number;
  response_inputs: FormResponseInput[];
  order: IOrder;
  created_at: string;
};

type IGetFormResponse = {
  cart_id?: number;
  order_id?: number;
  form_id?: number;
  order?: boolean;
};

export async function GetFormResponse(
  params: IGetFormResponse,
  useGlobalLoader = true,
): Promise<IFormResponseRes<FormResponse>> {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/client/form/response"), params, useGlobalLoader);
}
